import React, { useState, useEffect } from "react";
import { useDesignFormStore,FabricSpecsState } from "../../store/DesignMasterStore";
import axiosApi from "../../server/service";

import SearchableDropdown from "../../components/customUI/SearchableDropdown";

interface DropdownOption {
  _id: string;
  fabricType?: string;
  astarType?: string;
  vendorName?: string;
}

interface VendorOption {
  _id: string;
  vendorName: string;
  contactNumber: string;
}

const FabricSpecs: React.FC = () => {
  const { fabricSpecs, updateFabricSpecs, setFabricSpecs } =
    useDesignFormStore();

  const [fullFabricData, setFullFabricData] = useState<any[]>([]);

  const [fabricOptions, setFabricOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [isLoadingFabrics, setIsLoadingFabrics] = useState(true);

  const [vendorOptions, setVendorOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [isLoadingVendors, setIsLoadingVendors] = useState(true);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    updateFabricSpecs(name as keyof typeof fabricSpecs, value);
  };

  useEffect(() => {
    const fetchFabricTypes = async () => {
      setIsLoadingFabrics(true);
      try {
        const response = await axiosApi.get("/api/fabricTypes/for-dropdown");
        if (response.data.success && Array.isArray(response.data.data)) {
          const allFabrics = response.data.data;
          setFullFabricData(allFabrics);

          const formatted = response.data.data.map((item: DropdownOption) => ({
            label: item.fabricType!,
            value: item._id,
          }));
          setFabricOptions(formatted);
        }
      } catch (error) {
        console.error("Failed to fetch fabric types:", error);
      } finally {
        setIsLoadingFabrics(false);
      }
    };
    fetchFabricTypes();
  }, []);

  useEffect(() => {
    const fetchVendors = async () => {
      setIsLoadingVendors(true);
      try {
        const response = await axiosApi.get(
          "/api/vendors/getVendorsForDropdown",
          {
            params: { vendorType: "Fabric Supplier" },
          }
        );

        console.log("response", response);
        if (response.data.success && Array.isArray(response.data.data)) {
          // Format the API response for the Select component
          const formattedVendors = response.data.data.map(
            (vendor: VendorOption) => ({
              // label: `${vendor.vendorName}`,
              // value: `${vendor.vendorName}`,
              label: vendor.vendorName,
              value: vendor._id,
            })
          );
          setVendorOptions(formattedVendors);
        }
      } catch (error) {
        console.error("Failed to fetch vendors:", error);
      } finally {
        setIsLoadingVendors(false);
      }
    };

    fetchVendors();
  }, []);

  const handleFabricSelect = (selectedId: string) => {
    const selectedFabric = fullFabricData.find((f) => f._id === selectedId);

    if (selectedFabric) {
      const vendorId = selectedFabric.vendorDetails?._id || null;
      const newSpecs: Partial<FabricSpecsState> = {
        fabricType: selectedFabric._id,
        vendorDetails: vendorId,
        panna: selectedFabric.panna || "",
        pannaRate: selectedFabric.pannaRate?.toString() || "0.00",
        agentName: selectedFabric.agentName || "",
        discountDetails: selectedFabric.discountDetails || "",
        masterRecordRef: selectedFabric.masterRecordRef || "",
      };
      setFabricSpecs(newSpecs); 
    }
  };

  console.log(fabricSpecs, "fabricSpecs");


  return (
    <div className="bg-white p-1 rounded-xl shadow-sm">
      <h2 className="font-semibold text-2xl mb-5">Fabric Specifications</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Fabric Type */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Fabric Type/Name
          </label>
          <SearchableDropdown
            options={fabricOptions}
            value={fabricSpecs.fabricType || ""}
            // onChange={(value) => updateFabricSpecs("fabricType", value)}
            onChange={handleFabricSelect}
            placeholder="Select or search fabric..."
            loading={isLoadingFabrics}
          />
        </div>

        {/* Chart Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Chart Name
          </label>
          <input
            type="text"
            name="chartName"
            value={fabricSpecs.chartName}
            onChange={handleChange}
            placeholder="e.g., Chart A, Design Chart 1"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg "
          />
        </div>

        {/* Chart No */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Chart No.
          </label>
          <input
            type="text"
            name="chartNo"
            value={fabricSpecs.chartNo}
            onChange={handleChange}
            placeholder="e.g., CH001"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg "
          />
        </div>

        {/* Vendor */}
        {/* <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Vendor Details
          </label>
           <Select
            value={fabricSpecs.vendorDetails}
            onValueChange={(val: string) => updateFabricSpecs("vendorDetails", val)}
            >
            <SelectTrigger className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm min-h-[44px] h-auto">
                <SelectValue placeholder="Select vendor" />
            </SelectTrigger>

        <SelectContent className="bg-white shadow-lg rounded-lg border border-white max-w-[90vw]">
        
        {vendorOptions.map((vendor) => (
            <SelectItem
            key={vendor.value}
            value={vendor.value}
            className="cursor-pointer hover:bg-blue-50 py-2 px-3 rounded-md whitespace-normal break-words text-sm"
            >
            {vendor.label}
            </SelectItem>
        ))}
        </SelectContent>
      </Select>
        </div> */}

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Vendor Details
          </label>
          <SearchableDropdown
            options={vendorOptions}
            value={fabricSpecs.vendorDetails || ""}
            onChange={(value) => updateFabricSpecs("vendorDetails", value)}
            placeholder="Select or search for a vendor..."
            loading={isLoadingVendors}
          />
        </div>

        {/* Bill No */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Bill No. with Date
          </label>
          <input
            type="text"
            name="billNoWithDate"
            value={fabricSpecs.billNoWithDate}
            onChange={handleChange}
            placeholder="Bill number and date"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg "
          />
        </div>

        {/* Panna */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Panna
          </label>
          <input
            type="text"
            name="panna"
            value={fabricSpecs.panna}
            onChange={handleChange}
            placeholder="Panna details"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg "
          />
        </div>

        {/* Panna Rate */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Panna Rate
          </label>
          <input
            type="number"
            name="pannaRate"
            value={fabricSpecs.pannaRate}
            onChange={handleChange}
            placeholder="0.00"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg "
          />
        </div>

        {/* Agent Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Agent Name
          </label>
          <input
            type="text"
            name="agentName"
            value={fabricSpecs.agentName}
            onChange={handleChange}
            placeholder="Agent name"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg "
          />
        </div>

        {/* Discount */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Discount Details
          </label>
          <input
            type="text"
            name="discountDetails"
            value={fabricSpecs.discountDetails}
            onChange={handleChange}
            placeholder="Discount information"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg "
          />
        </div>

        {/* Master Reference */}
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Master Record Reference
          </label>
          <input
            type="text"
            name="masterRecordRef"
            value={fabricSpecs.masterRecordRef}
            onChange={handleChange}
            placeholder="Reference to master fabric record"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg "
          />
        </div>

        {/* Notes */}
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Additional Fabric Notes
          </label>
          <textarea
            name="fabricNotes"
            value={fabricSpecs.fabricNotes}
            onChange={handleChange}
            placeholder="Special instructions, care instructions, etc."
            className="w-full px-3 py-2 border border-gray-300 rounded-lg "
          />
        </div>
      </div>
    </div>
  );
};

export default FabricSpecs;
